import { Button } from "@pankod/refine-antd";
import React from "react";

export const ButtonFilter: React.FC = () => (
  <Button htmlType="submit" type="primary">
    Filter
  </Button>
);
